import React from "react"

const Separator = ({ className = "", orientation = "horizontal", ...props }) => {
  const baseClasses = orientation === "horizontal" 
    ? "h-[1px] w-full" 
    : "h-full w-[1px]"
  
  return (
    <div
      className={`shrink-0 bg-gray-700 ${baseClasses} ${className}`}
      {...props}
    />
  )
}

export { Separator }
